import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/foot_img.png';
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = {
  key: 0,
  class: "footer-right"
};
const _hoisted_4 = {
  class: "footer-column"
};
const _hoisted_5 = {
  key: 0,
  class: "column-item"
};
const _hoisted_6 = {
  key: 1,
  class: "column-item"
};
const _hoisted_7 = {
  key: 2,
  class: "column-item"
};
const _hoisted_8 = {
  key: 3,
  class: "column-item"
};
const _hoisted_9 = {
  key: 4,
  class: "column-item"
};
const _hoisted_10 = {
  href: "http://beian.miit.gov.cn",
  target: "_blank",
  style: {
    "color": "rgba(255, 255, 255, 0.7)"
  }
};
const _hoisted_11 = {
  key: 0,
  class: "footer-column"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 1,
  class: "footer-column no-title"
};
const _hoisted_15 = ["href"];
const _hoisted_16 = {
  key: 1
};
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getFooterInfo } from '@/api/common';
export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {
    const router = useRouter();
    const footerData = ref(null);
    // 处理联系方式数据
    const contactInfo = computed(() => {
      if (!footerData.value || !footerData.value.data_contact_information) {
        return null;
      }
      return footerData.value.data_contact_information;
    });
    // 处理友情链接数据
    const friendlyLinks = computed(() => {
      if (!footerData.value || !footerData.value.data_friendly_link) {
        return [];
      }
      const links = footerData.value.data_friendly_link;
      return Object.keys(links).map(name => ({
        name,
        url: links[name]
      }));
    });
    const fetchFooterInfo = async () => {
      try {
        const res = await getFooterInfo();
        if (res.data) {
          footerData.value = res.data;
        }
      } catch (error) {
        console.error('获取底部信息失败:', error);
      }
    };
    onMounted(() => {
      fetchFooterInfo();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "footer-left"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "footer",
        class: "footer-img"
      })], -1)), contactInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "column-title"
      }, "联系方式", -1)), contactInfo.value['地址'] ? (_openBlock(), _createElementBlock("div", _hoisted_5, "地址/ " + _toDisplayString(contactInfo.value['地址']), 1)) : _createCommentVNode("", true), contactInfo.value['电话'] ? (_openBlock(), _createElementBlock("div", _hoisted_6, "电话/ " + _toDisplayString(contactInfo.value['电话']), 1)) : _createCommentVNode("", true), contactInfo.value['邮编'] ? (_openBlock(), _createElementBlock("div", _hoisted_7, "邮编/ " + _toDisplayString(contactInfo.value['邮编']), 1)) : _createCommentVNode("", true), contactInfo.value['版权所有'] ? (_openBlock(), _createElementBlock("div", _hoisted_8, "版权所有/ " + _toDisplayString(contactInfo.value['版权所有']), 1)) : _createCommentVNode("", true), contactInfo.value['公安网备案'] ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[0] || (_cache[0] = _createTextVNode("公安网备案/ ", -1)), _createElementVNode("a", _hoisted_10, _toDisplayString(contactInfo.value['公安网备案']), 1)])) : _createCommentVNode("", true)]), friendlyLinks.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "column-title"
      }, "友情链接", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friendlyLinks.value.slice(0, 5), (link, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "column-item"
        }, [link.url && link.url !== '#' ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: link.url,
          target: "_blank",
          class: "link"
        }, _toDisplayString(link.name), 9, _hoisted_12)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(link.name), 1))]);
      }), 128))])) : _createCommentVNode("", true), friendlyLinks.value.length > 5 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "column-title"
      }, " ", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friendlyLinks.value.slice(5), (link, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "column-item"
        }, [link.url && link.url !== '#' ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: link.url,
          target: "_blank",
          class: "link"
        }, _toDisplayString(link.name), 9, _hoisted_15)) : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(link.name), 1))]);
      }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
    };
  }
});